import React from 'react';
import "./EditTable.scss";
import EditStratificationDates from "../Maintenence/EditStratificationDates"; 
import EditStratLocations from "../Maintenence/EditStratLocations";
import EditSpeciesStratDayGenera from "../Maintenence/EditSpeciesStratDayGenera";
import EditSeedsPerCell from "../Maintenence/EditSeedsPerCell";
import EditFacilityInfo from "../Maintenence/EditFacilityInfo";
import TabPanel, { Item } from "devextreme-react/tab-panel";

class EditTables extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <TabPanel className='h-100 m-0' style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Item className="h-100" title="Stratification Dates">
            <EditStratificationDates/>
          </Item>
          <Item className="h-100" title="Seeds Per Cell">
            <EditSeedsPerCell/>
          </Item>
          <Item className="h-100" title="Species Strat Day Genus">
            <EditSpeciesStratDayGenera/>
          </Item>
          <Item className="h-100" title="Strat Location">
            <EditStratLocations/>
          </Item>
          <Item className="h-100" title="Facility Info">
            <EditFacilityInfo/>
          </Item>
      </TabPanel>
    );
  }
}

  export default EditTables;
